import Api from './api.js';
import axios from 'axios';

export class ProductApi extends Api {
    constructor(options = {}) {
        super(options);

        this.apiPath = 'produtos';
    }

    async getProductsList(){
        return await this.axiosInstance.request({
            method: 'get',
            url: this.apiPath + '?_limit=10000',
        });
    }
}
